import React, {Component} from 'react'
import axios from 'axios'
import { fabric } from 'fabric';
import * as _ from 'lodash-joins'
import CS from '../../commons/services/Common'
import SortableTree, { addNodeUnderParent, removeNodeAtPath } from 'react-sortable-tree';
import FileExplorerTheme from 'react-sortable-tree-theme-file-explorer';
import 'react-sortable-tree/style.css';

var SCALE_FACTOR = 1;
var TEMPLATE_WIDTH = 600;
var TEMPLATE_HEIGHT = 500;
var TEMP_MODULE_TITLE = "";
var TEMPINVERTER_ID = "";
var MODULE_SN = 0;
var isDrag = false;
var h = [];
var PREV_GROUP;
var PREV_GROUP_O;

class DrawingModuleV2 extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            isModal: false,
            batchType: 'row',
            plantId: props.match.params.plantId,
            row: 5,
            col: 2,
            azimuth: 0,
            objCnt: 0,
            bModInfos: [],
            aModInfos: [],
            searchSerialNo: '',

            plantInfo: {},
            treeData: []
        }
        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.buildModule = this.buildModule.bind(this);

        this.modInfos = [];
    }

    componentDidMount = () => { 
        this.buildCanvas();
        this.getPlantInfo();
    }


    getPlantInfo = async() => {
        const {plantId} = this.state;
        const res = await axios.get(`/usr/api/user-plant/info?plantIds=${plantId}`);
        this.setState({
            plantInfo: res.data[0],
        });
        this.getPlantEquipment(plantId);
    }

    async getPlantEquipment(plantId) {
        const {plantInfo} = this.state;
        const data = {
            level: 0,
            id: plantId,
            title: plantInfo.name,
            parent: '0'
        }
        try {
            const res = await axios.get(`/cst/api/constructor-plant/equipment/${plantId}`);
            
            const children = [];
            res.data.some(v => {
                children.push({
                    level: 1,
                    id: v.id,
                    title: v.title,
                    inverter: {
                        no: v.inverterNo,
                        name: v.inverterName,
                        manufacturer: v.inverterManufacturer,
                        capacity: v.inverterCapacity,
                        rtuNo: v.inverterRtuNo
                    },
                    module: {
                        name: v.moduleName,
                        manufacturer: v.moduleManufacturer,
                        power: v.modulePower,
                        cnt: v.moduleCnt
                    },
                    parent: v.plantId,
                    children: JSON.parse(v.stringInfo)
                })
            });
            data.children = children;
            const treeData = [];
            treeData.push(data);
            this.setState({
                treeData: treeData
            });
            this.buildModules(treeData);
        } catch (error) {
            console.error("Fetch Error: ", error);
        }
    }

    buildModules = (treeData) => {
        let title, ci, rect, text, group, inverterNo;
        treeData.some(v1 => {
            v1.children.some(v2 => {
                //console.log(v2);
                inverterNo = v2.inverter.no;
                v2.children.some(v3 => {
                    v3.children.some(v4 => {
                        title = v4.title;
                        ci = v4.canvasInfo;
                        rect = new fabric.Rect({
                            width: 15,
                            height: 30,
                            stroke: 'red',
                            fill: '#d6f71a'
                        });
                        text = new fabric.Text(title, {
                            visible: false,
                            fontSize: 0
                        });
                        group = new fabric.Group([ rect, text ], {
                            type: "module",
                            title: title,
                            zigbee: v4.zigbee,
                            inverterNo: inverterNo,
                            left: ci?.leftX || 0,
                            top: ci?.topY || 0,
                            angle: ci?.azimuth || 0,
                            hasControls: false,
                            draggable: false
                        });

                        this.canvas.add(group);
                        group.on("drop", function(e) {
                            let text = this._objects[1].text;
                            this._objects[0].set('fill', '#d6f71a');
                            this._objects[1].set('text', title);
                            this.canvas.renderAll();
                            isDrag = true;
                        });
                        group.on("mouseover", function(e) {
                            let text = this._objects[1].text.split('&')[1];
                            if(text === '') {
                                this._objects[0].set('fill', 'rgba(255,199,214,100)');
                                this.canvas.renderAll();
                            }
                        });
                        group.on("mouseout", function(e) {
                            let text = this._objects[1].text.split('&')[1];
                            if(text === '') {
                                this._objects[0].set('fill', '#00006F');
                                this.canvas.renderAll();
                            }
                        });
                    });
                });
            });
        });
    }

    buildCanvas() {
        this.canvas = this.__canvas = new fabric.Canvas('c');

        /*
        this.canvas.on('mouse:dblclick', (e) => {
            console.log("double click...")
        });
        */

        //rotated, rotating
        this.canvas.on('object:rotating', (e) => {
            let idx = e.target._objects[0]._objects[1].text.split('&')[0];
            let angle = Math.round(this.canvas.toJSON().objects[idx].angle);
            this.setState({
                azimuth: (angle < 0) ? angle + 360 : angle
            });
        });

        this.canvas.on("object:moving", function(e) {
            //console.log(e.target);
        })      
    }



    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    buildModule = () => {
        TEMP_MODULE_TITLE = "";
        let imgElement = document.getElementById('panel-image');
        let width = (this.state.batchType === 'row') ? 15 : 30;
        let height = (this.state.batchType === 'row') ? 30 : 15;
        let row = this.state.row;
        let col = this.state.col;
        let angle = this.state.azimuth;

        for (let i=0; i<col; i++) {
            
            let x1 = 50 + ((height+2)*i * Math.sin(CS.calcDegressToRadian(360-angle)));
            let y1 = 50 + ((height+2)*i * Math.cos(CS.calcDegressToRadian(360-angle)));
            
            for (let j=0; j<row; j++) {

                const x2 = x1 + (height * Math.sin(CS.calcDegressToRadian(360-angle)));
                const y2 = y1 + (height * Math.cos(CS.calcDegressToRadian(360-angle)));
                const x3 = x2 + (width * Math.cos(CS.calcDegressToRadian(360-angle)));
                const y3 = y2 - (width * Math.sin(CS.calcDegressToRadian(360-angle)));
                const x4 = x3 - (height * Math.sin(CS.calcDegressToRadian(360-angle)));
                const y4 = y3 - (height * Math.cos(CS.calcDegressToRadian(360-angle)));


                let polygon = new fabric.Polygon(
                    [
                        { x: x1, y: y1 },
                        { x: x2, y: y2 },
                        { x: x3, y: y3 },
                        { x: x4, y: y4 }
                    ],
                    {
                        fill: '#00006F',
                        stroke: 'red',
                        moduleSerialNo: null,
                    }
                );

                let imgInstance = new fabric.Image(imgElement, {
                    width: width,
                    height: height,
                    //opacity: 0.85,
                });

                let text = new fabric.Text(TEMP_MODULE_TITLE, {
                    visible: false,
                    fontFamily: 'Courier New',
                    fontSize: 10,
                    fontSize: 0,
                    left: x1,
                    top: y1,
                });

                let group = new fabric.Group([ polygon, text ], {
                    hasControls: false,
                    draggable: false
                });

                x1 = x1 + ((width+2) * Math.cos(CS.calcDegressToRadian(360-angle)));
                y1 = y1 - ((width+2) * Math.sin(CS.calcDegressToRadian(360-angle)));
                

                this.canvas.add(group);
                group.on("drop", function(e) {
                    isDrag = true;
                });

                group.on("mousedblclick", function(e) {
                    this._objects[0].set('fill', '#d6f71a');
                    this._objects[1].set('text', TEMP_MODULE_TITLE);
                    this.canvas.renderAll();
                });
                group.on("mouseover", function(e) {
                    let text = this._objects[1].text.split('&')[1];
                    if (text === '') {
                        this._objects[0].set('fill', 'rgba(255,199,214,100)');
                        this.canvas.renderAll();
                    }
                });
                group.on("mouseout", function(e) {
                    let text = this._objects[1].text.split('&')[1];
                    if(text === '') {
                        this._objects[0].set('fill', '#00006F');
                        this.canvas.renderAll();
                    }
                });
                //groups.addWithUpdate(group);
            }
        }
        this.modalHandler(false);
    }

    create = async() => {
        const canvasData = this.canvas.toJSON().objects;
        const {treeData} = this.state;
        treeData.some(v1 => {
            v1.children.some(v2 => {
                v2.children.some(v3 => {
                    v3.children.some(v4 => {
                        const idx = canvasData.findIndex((e, index, array) => {
                            return e.objects[1].text == v4.title;
                        });
                        if (idx > -1) {
                            const dI = canvasData[idx];
                            v4.canvasInfo = {
                                azimuth: dI.angle,
                                leftX: dI.left,
                                topY: dI.top,
                            }
                        }
                    });
                });
            });
        });
        //console.log(treeData);

        const params = [];
        treeData[0].children.some(v => {
            params.push({
                id: v.id,
                plantId: Number(v.parent),
                title: v.title,
                level: v.level,
                inverter: v.inverter,
                module: v.module,
                stringInfo: JSON.stringify(v.children)
            });
        });
        try {
            await axios.post(`/cst/api/constructor-plant/equipment/${this.state.plantId}`, params)
            alert("저장되었습니다.");
        } catch (error) {
            console.error("Fetch Error: ", error);
        }
    }

    connectedLines = (stringId) => {
        const {treeData} = this.state;
        const canvasData = this.canvas._objects;
        
        treeData.some(v1 => {
            v1.children.some(v2 => {
                v2.children.some(v3 => {
                    if (v3.title == stringId) {
                        let modules = v3.children.sort((a, b) => {
                            let aT = parseInt(a.title.split(".")[2]);
                            let bT = parseInt(b.title.split(".")[2]);
                            return aT - bT;
                        });
                        let grp1, grpIdx1, grp2, grpIdx2, connector;
                        const connectors = [];
                        for (let i = 0; i < modules.length - 1; i++) {
                            grpIdx1 = canvasData.findIndex((e) => {
                                return e.title == modules[i].title;
                            });
                            grpIdx2 = canvasData.findIndex((e) => {
                                return e.title == modules[i+1].title;
                            });
                            grp1 = canvasData[grpIdx1].getCenterPoint();
                            grp2 = canvasData[grpIdx2].getCenterPoint();
                            connector = new fabric.Line(
                                [grp1.x, grp1.y, grp2.x, grp2.y], {
                                    stroke: 'black',
                                    strokeWidth: 1.5,
                                    strokeDashArray: [3, 5],
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockRotation: false,
                                    hasControls: false,
                                    hasBorders: false,
                                    lockMovementX: true,
                                    lockMovementY: true
                                }
                            )
                            connectors.push(connector);
                        }
                        const lineGroup = new fabric.Group(connectors, {
                            type: "string",
                            title: stringId,
                            hasControls: false,
                            draggable: false
                        });
                        this.canvas.add(lineGroup);
                        return true;
                    }
                });
            });
        });
    }

    handleMouserOver = (action, title) => {
        const titleArr = title.split(".");
        if (titleArr.length > 1) {
            let idx;
            const co = this.canvas._objects;
            switch (titleArr.length) {
                case 3:
                    idx = co.findIndex((e) => {
                        return e.type == "module" && e.title == title;
                    });
                    if (idx > -1) {
                        co[idx]._objects[0].set('fill', action == "out" ? "#d6f71a" : "red");
                        this.canvas.renderAll();
                    }
                    break;
                case 2:
                    idx = co.findIndex((e) => {
                        return e.type == "string" && e.title == title;
                    });
                    if (idx > -1) {
                        co.splice(idx, 1);
                        this.canvas.renderAll();
                    } else {
                        this.connectedLines(title)
                    }
                    break;
            }
        }
        
    } 

    zoomInAndOut = (val) => {
        SCALE_FACTOR = Number(SCALE_FACTOR) + val;
        SCALE_FACTOR = Number(SCALE_FACTOR).toFixed(1);
        let tmWidth = TEMPLATE_WIDTH * SCALE_FACTOR;
        let tmHeight = TEMPLATE_HEIGHT * SCALE_FACTOR;
        this.canvas.setZoom(SCALE_FACTOR);
        this.canvas.calcOffset();
        this.canvas.renderAll();
    }

    undo = () => {
        if(this.canvas._objects.length>0){
            h.push(this.canvas._objects.pop());
            this.canvas.renderAll();
        }
    }

    redo = () => {
        if(h.length>0){
           //isRedoing = true;
           this.canvas.add(h.pop());
        }
    }


    getSerialNo = (object) => {
        return object.text.split("&")[1];
    }

    modalHandler = (is) => {
        this.setState({
            isModal: is
        })
    }

    render() {
        const {
            bModInfos, aModInfos, searchSerialNo, isModal, batchType,
            treeData
        } = this.state;
        const getNodeKey = ({ treeIndex }) => treeIndex;
        return (
            <>           
                <div className="page-tit">
                    <div className="container location">
                        <h2 className="tit">전체 발전소 리스트</h2>
                        <span>
                            <strong>대기 발전소 등록</strong>
                        </span>
                    </div>
                </div>
                <section className="module-match">
                    <div className="container">
                        <div className="h-stack">
                            <div className="l-area">
                                <div className="head">
                                    <button type="button" className="btn blue w245 radius15"><i className="material-icons size20">folder</i> 시리얼 넘버 불러오기</button>
                                </div>
                                <div className="card h654 py-25 px-12">
                                    <SortableTree
                                        theme={FileExplorerTheme}
                                        canDrag={false}
                                        onMoveNode={false}
                                        treeData={this.state.treeData}
                                        onChange={treeData => this.setState({ treeData })}
                                        generateNodeProps={({ node, path }) => ({
                                            title: (
                                                <>
                                                    <button
                                                        type="button"
                                                        draggable="true"
                                                        onMouseOver={() => {this.handleMouserOver("over", node.title)}}
                                                        onMouseOut={() => {this.handleMouserOver("out", node.title)}}
                                                        onClick={
                                                            () => {
                                                                TEMP_MODULE_TITLE = node.title;
                                                            }
                                                        }
                                                    >{node.title}
                                                    </button>
                                                </>
                                            ),
                                        })}
                                    />
                                </div>
                            </div>
                            <div className="r-area">
                                <div className="head">
                                    <button type="button" className="btn secondary w245 radius15" onClick={() => this.modalHandler(true)}><i className="material-icons size20">edit</i> 모듈 그리기 추가</button>
                                    <button type="button" className="btn primary2 radius15" onClick={this.deleteObject}><i className="material-icons size14">remove</i> 모듈 삭제</button>
                                    <button type="button" className="btn primary2 radius15" onClick={this.buildModule}><i className="material-icons size14">add</i> 모듈 추가</button>
                                    <button type="button" className="btn primary2 radius15" onClick={this.connectedLines}><i className="material-icons size14">add</i> 결선</button>
                                </div> 
                                <div className="card m-map h654" style={{overflow: "scroll"}}>
                                    <canvas id="c" width="1500" height="1500"></canvas>
                                    <div className="control-btn">
                                        <button type="button" onClick={() => this.zoomInAndOut(0.1)}>
                                            <img src="/images/ctors/map/zoom-in.png" alt="확대" />
                                        </button>
                                        <button type="button">
                                            <img src="/images/ctors/map/zoom-reset.png" alt="초기화" />
                                        </button>
                                        <button type="button" onClick={() => this.zoomInAndOut(-0.1)}>
                                            <img src="/images/ctors/map/zoom-out.png" alt="축소" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-areaC1">
                            <button type="button" className="btn shadow1" onClick={this.create}>임시저장</button>
                            <button type="button" className="btn primary" onClick={this.create}>등록완료</button>&nbsp;&nbsp;
                        </div>
                    </div>
                </section>


                <div className={isModal ? 'modal show' : 'modal'} id="directInputModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered max-w470">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="form-inline3 form-tit14">
                                    <div className="form-group">
                                        <label className="tit w60">행 개수</label>
                                        <input type="number" className="w115 center" name="row" value={this.state.row} onChange={this.handleInputChange} min="0" max="10" />
                                        <label className="tit ml-20">열 개수</label>
                                        <input type="number" className="w115 center" name="col" value={this.state.col} onChange={this.handleInputChange} min="0" max="10" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w60">배치 선택</label>
                                        <button className={batchType == 'row' ? 'btn w145 h48 primary' : 'btn w145 h48 '} onClick={() => this.chooseBatchType('row')}>가로배치</button>
                                        <button className={batchType == 'col' ? 'btn w145 h48 ml-18 primary' : 'btn w145 h48 ml-18'} onClick={() => this.chooseBatchType('col')}>세로배치</button>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w60">방위각</label>
                                        <input type="tel" className="w315 center" name="azimuth" value={this.state.azimuth} onChange={this.handleInputChange} />
                                    </div>
                                </div>
                                <div className="foot-btn">
                                    <button type="button" className="btn" onClick={() => this.modalHandler(false)}>취소</button>
                                    <button type="button" className="btn primary" onClick={this.buildModule}>완료</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    
}

export default DrawingModuleV2;
